export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const STATUS_CONFIG = {
  novo: {
    label: 'Nova',
    color: '#3B82F6',
    bg: '#EFF6FF',
  },
  recorrente: {
    label: 'Recorrente',
    color: '#1B4332',
    bg: '#F0FDF4',
  },
  inativo: {
    label: 'Inativa',
    color: '#DC2626',
    bg: '#FEF2F2',
  },
};

export const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value || 0);
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  try {
    const d = new Date(dateStr);
    return d.toLocaleDateString('pt-BR');
  } catch {
    return dateStr;
  }
};

export const formatDateRelative = (dateStr) => {
  if (!dateStr) return 'Nunca';
  try {
    const d = new Date(dateStr);
    const now = new Date();
    const diff = Math.floor((now - d) / (1000 * 60 * 60 * 24));
    if (diff === 0) return 'Hoje';
    if (diff === 1) return 'Ontem';
    if (diff < 7) return `${diff} dias`;
    if (diff < 30) return `${Math.floor(diff / 7)} sem.`;
    if (diff < 365) return `${Math.floor(diff / 30)} meses`;
    return d.toLocaleDateString('pt-BR');
  } catch {
    return dateStr;
  }
};

export const formatPhone = (phone) => {
  if (!phone) return '';
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 11) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  return phone;
};
